// import {Button, MenuItem} from '@blueprintjs/core';
// import { Select } from '@blueprintjs/select';
import React from "react";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { withStyles } from "@material-ui/core/styles";
import MuiTablePagination from "@material-ui/core/TablePagination";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const defaultFooterStyles = {};

class CustomFooter extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            totalPages: '',
            arrayOfPages: [],
        }
    }
    handleRowChange = event => {
        this.props.changeRowsPerPage(event.target.value);
    };

    handlePageChange = (_, page) => {
        this.props.changePage(page);
    };

    componentDidMount(){
        this.getArrayOfPages()
    }

    componentDidUpdate(){
        if(parseInt(this.props.totalPages) !== parseInt(this.state.totalPages)){
            this.getArrayOfPages();
        }
    }

    getArrayOfPages = () => {
        let arrayOfPages = [];
        let total = parseInt(this.props.totalPages);
        let page = 1;
        for (let i = 0; i < total; i++){
            arrayOfPages.push(page);
            // total--;
            page++
            // console.log('arrayOfPages in loop:',arrayOfPages, total, page)
        }
        this.setState({totalPages: total, arrayOfPages})
        // console.log('arrayOfPages:',arrayOfPages, total, page, this.state)
    }

    render() {
        const { count, classes, textLabels, rowsPerPage, page } = this.props;

        const footerStyle = {
            display:'flex',
            justifyContent: 'flex-end',
            padding: '0 24px 0 24px'
        };

        return (
            <TableFooter>
                <TableRow>
                    <TableCell style={footerStyle} className='contacts-table-footer' colSpan={1000}>
                        <p className='margin-right-10'>Select page:</p>
                        {/*<Select*/}
                        {/*    items={this.state.arrayOfPages}*/}
                        {/*    itemRenderer={(item, index) => <MenuItem*/}
                        {/*        key={index}*/}
                        {/*        onClick={() => {*/}
                        {/*            this.setState({*/}
                        {/*                selectedTimeZone: item*/}
                        {/*            })*/}
                        {/*        }}*/}
                        {/*        text={item}*/}
                        {/*    />}*/}
                        {/*    onItemSelect={this.countrySelect}*/}
                        {/*    filterable={false}*/}
                        {/*>*/}
                        {/*    <Button text={this.props.page+1} rightIcon="caret-down"></Button>*/}
                        {/*</Select>*/}
                        <Select
                            id='mui-page-select'
                            value={this.props.page + 1}
                            onChange={(item)=>this.props.changePage(item.target.value-1)}
                        >
                            {this.state.arrayOfPages.map(thisPage=><MenuItem key={thisPage} value={thisPage}>{thisPage}</MenuItem>)}
                        </Select>
                        <MuiTablePagination
                            component="div"
                            count={count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            labelRowsPerPage={textLabels.rowsPerPage}
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${textLabels.displayRows} ${count}`}
                            backIconButtonProps={{
                                'aria-label': textLabels.previous,
                            }}
                            nextIconButtonProps={{
                                'aria-label': textLabels.next,
                            }}
                            rowsPerPageOptions={[25, 50, 100]}
                            onChangePage={this.handlePageChange}
                            onChangeRowsPerPage={this.handleRowChange}
                        />
                    </TableCell>
                </TableRow>
            </TableFooter>
        );
    }
}

export default withStyles(defaultFooterStyles, { name: "CustomFooter" })(
    CustomFooter
);
